import React, { useEffect, useRef, useState } from "react";
import {
  formBtn1,
  formBtn2,
  inputClass,
  pageClass,
  pageHeader,
} from "../Utils/CustomClasses";
import AddRole from "./AddRole";
import Table from "../Table/Table";
import { GetAllCompanyAPI, RolesPaginationAPI } from "../../API/Api";
import { useForm } from "react-hook-form";
import usePaginatedData from "../Utils/UsePagination";
import ViewRoleModal from "../Modals/ViewRoleModal";
import DeleteRoleModal from "../Modals/DeleteRoleModal";
import { useSelector } from "react-redux";
import { useThemeColor } from "../Sidebar/SideBarApi";
import { toast } from "react-toastify";
import { IconEye } from "@tabler/icons-react";

export default function Role() {
  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors },
    setValue,
  } = useForm();
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const initialFilterState = {
    p: 1,
    companyId:
      UserDetails?.role?.roleName == "SuperAdmin"
        ? ""
        : UserDetails?.company?._id,
  };
  const [filterObject, setFilterObject] = useState({ ...initialFilterState });
  const [Company, setCompany] = useState([]);
  const [RowData, setrowdata] = useState([]);
  const [RoleModal, setRoleModal] = useState(false);
  const filterTimeout = useRef();
  const isFirstRender = useRef(true);
  let companyId = watch("companyId");
  const themeColor = useThemeColor();

  const {
    filterData: roleData,
    pageNo,
    nextIsValid,
    prevIsValid,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
    loader,
  } = usePaginatedData(1, 50, RolesPaginationAPI, filterObject);
  
  const HandleViewRoles = (row) => {
    setrowdata(row);
    setRoleModal(true);
  };

  const tableColumns = [
    {
      field: "hierarchyLevel",
      header: "Hierarchy Level",
      style: true,
      body: (row) => <h6>{row?.hierarchyLevel}</h6>,
    },
    {
      field: "roleName",
      header: "Role Name",
      style: true,
      body: (row) => <h6>{row?.roleName}</h6>,
    },
    {
      field: "companyName",
      header: "Company Name",
      style: true,
      body: (row) => <h6>{row?.company?.companyName}</h6>,
    },
    {
      field: "actions",
      header: "Actions",
      style: true,
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            className="py-1 rounded-lg flex justify-center w-[10%]"
            onClick={(e) => {
              e.preventDefault();
              HandleViewRoles(row);
            }}
          >
            <IconEye stroke={1.5} size={24} color="#000" />
          </button>
          {UserDetails?.role?.roleName === "SuperAdmin" ||
          (UserDetails?.role?.roleName !== "SuperAdmin" &&
            row.roleName !== "Admin") ? (
            <>
              <AddRole
                edit={true}
                rowdata={row}
                filterRecords={filterRecords}
              />
              <DeleteRoleModal data={row} filterRecords={filterRecords} />
            </>
          ) : null}
        </div>
      ),
    },
  ];

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  const getallCompany = async (companyId) => {
    try {
      if (UserDetails?.role?.roleName == "SuperAdmin") {
        const res = await GetAllCompanyAPI(companyId);
        setCompany(res?.data?.filteredData);
      } else {
        setCompany([]);
      }
    } catch (err) {
      console.log("Error:", err);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    filterRecords();
  }, [filterObject]);

  useEffect(() => {
    getallCompany(UserDetails?.company?._id);
  }, []);

  const filterSubmit = (data) => {
    if (data?.companyId == "") {
      toast.error("Please select company name");
      return;
    }
    setFilterObject((prevState) => ({
      ...prevState,
      companyId: data?.companyId ? data?.companyId : "",
    }));
  };
  return (
    <>
      <div className={`${pageClass}`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between">
            <h1 className={`${pageHeader}`}>Roles</h1>
            <AddRole
              filterRecords={filterRecords}
              edit={false}
              Company={Company}
            />
          </div>
          {UserDetails?.role?.roleName == "SuperAdmin" && (
            <div className="bg-white rounded-xl mt-4">
              <form
                onSubmit={handleSubmit(filterSubmit)}
                className="flex flex-col lg:flex-row gap-3"
              >
                {/* FILTERS */}
                <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                  <div>
                    <select
                      name="company_id"
                      className={`${inputClass} !bg-slate-100 ${
                        companyId == "" ? "text-slate-400" : ""
                      }`}
                      {...register("companyId")}
                    >
                      <option value="">Company Name</option>

                      {Company?.map((company) => (
                        <option
                          key={company?._id}
                          value={company?._id}
                          className="text-black"
                        >
                          {company?.companyName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* BUTTONS */}
                <div className="flex gap-2 justify-end flex-shrink-0 items-center">
                  <button type="submit" className={`${formBtn1}`}>
                    Apply
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      reset();
                      setFilterObject(initialFilterState);
                    }}
                    className={`${formBtn2}`}
                  >
                    Clear
                  </button>
                </div>
              </form>
            </div>
          )}
          <div className="mt-4">
            <Table
              columns={tableColumns}
              data={roleData}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              loading={loader}
            />
          </div>
          <ViewRoleModal
            RoleModal={RoleModal}
            setRoleModal={setRoleModal}
            row={RowData}
          />
        </div>
      </div>
    </>
  );
}
